<template>
  <UCard>
    <template #header>
      <div class="text-center">
        <img src="/logo-vertical.svg" alt="GremiumHub" class="mx-auto mb-6 h-24" />
        <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          {{ $t('auth.welcome') }}
        </h1>
      </div>
    </template>

    <div class="text-center">
      <UButton color="primary" size="xl" icon="i-lucide-log-in" @click="handleSignIn">
        {{ $t('auth.signIn') }}
      </UButton>
    </div>

    <template #footer>
      <div class="text-center text-xs text-gray-500">
        {{ $t('auth.termsAgreement') }}
      </div>
    </template>
  </UCard>
</template>

<script setup lang="ts">
definePageMeta({ auth: false, layout: 'auth' })

const { t: $t } = useI18n()
const { loggedIn, openInPopup } = useUserSession()

useSeoMeta({ title: $t('auth.login') })

watch(loggedIn, (isLoggedIn) => {
  if (isLoggedIn) {
    navigateTo('/')
  }
})

function handleSignIn() {
  openInPopup('/auth/keycloak')
}
</script>
